import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import * as animation from "@universityofmaryland/web-styles-library/animation";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { wrapTextNodeInSpan } from "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../atomic/layout/block/stacked.js";
import { image, details, contact } from "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../atomic/text-lockup/small.js";
const smallBreakpoint = token.media.breakpointValues.small.max;
const CreatePersonTabularElement = ({
  actions,
  additionalContact,
  address,
  slotTwo,
  email,
  image: image$1,
  isThemeDark,
  slotOne,
  linkedin,
  name,
  phone,
  slotThreeItalic,
  slotFour
}) => {
  const builder = new ElementBuilder().withClassName("person-tabular-container").withStyles({
    element: {
      overflow: "hidden",
      display: "flex",
      ...createMediaQuery("max-width", smallBreakpoint, {
        flexDirection: "column"
      })
    }
  });
  if (image$1) {
    builder.withChild(
      image({
        image: image$1,
        isThemeDark
      })
    );
  }
  if (name) {
    const nameStyles = {
      ...animation.line.composeSlideUnder({
        color: theme.foreground(isThemeDark)
      }),
      ...typography.sans.compose("large", {
        theme: theme.fontColor(isThemeDark)
      })
    };
    const nameComposite = new ElementBuilder(name).withClassName("person-tabular-name").styled(nameStyles).withStyles({
      element: {
        fontWeight: `${token.font.weight.bold}`,
        [`& + *`]: {
          marginTop: token.spacing.min
        }
      },
      subElement: {
        color: "currentColor"
      }
    }).withModifier((el) => wrapTextNodeInSpan(el)).build();
    builder.withChild(
      details({
        actions,
        slotTwo,
        isThemeDark,
        customStyles: {},
        slotOne,
        nameComposite,
        slotThreeItalic,
        slotFour
      })
    );
  }
  if (additionalContact || address || email || linkedin || phone) {
    builder.withChild(
      contact({
        additionalContact,
        address,
        customStyles: {},
        email,
        isThemeDark,
        linkedin,
        phone
      })
    );
  }
  return builder.build();
};
const createCompositePersonTabular = CreatePersonTabularElement;
export {
  createCompositePersonTabular
};
//# sourceMappingURL=tabular.js.map
